import defaults from './defaults';

export default {
  ...defaults,
  sentry: {
    ...defaults.sentry,
    enabled: false,
    environment: 'local',
  },
};
